<template>
  <footer class="footer">
    <div class="footer-content">
      <a :href="whitepaperLink" target="_blank" rel="noopener noreferrer">
        <i class="fas fa-file-alt"></i> White Paper
      </a>

      <a href="https://discord.com/invite/SKXRnek3" target="_blank" rel="noopener noreferrer">
        <i class="fab fa-discord"></i> Discord
      </a>
      <a href="https://x.com/coin_platy77830" target="_blank" rel="noopener noreferrer">
        <i class="fab fa-twitter"></i> Twitter
      </a>

      <a @click.prevent="addTokenInWallet" href="#">
        <i class="fas fa-wallet"></i> Add to MetaMask
      </a>

      <a href="https://t.me/+J9Pm353Oth9jMjNh" target="_blank" rel="noopener noreferrer">
        <i class="fab fa-twitter"></i> Telegran
      </a>

      <a href="mailto:platypusmemecoin@gmail.com" target="_blank" rel="noopener noreferrer">
        <i class="fab fa-twitter"></i> platypusmemecoin@gmail.com
    </a>
    </div>

    <div class="footer-logo">
      <img :src="logo" alt="Logo" />
      <span>@2024 Platypus coin</span>
    </div>


    
    
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      logo: require('@/assets/logo.png') ,// Ensure this path is correct
      whitepaperLink: "https://ibb.co/YD2dTfS"
    };
  },
  methods: {
    addTokenInWallet: function() {
      try {
        const params = {
          type: 'ERC20',
          options: {
            address: '0x6EC063057eE3D6fE80f913204172762922d507Cc',
            symbol: 'PLAT',
            decimals: 18,
            image: "https://platypuscoin.web.app/img/logo.ddb0d27c.png"
          }
        };

        window.ethereum.request({ method: 'wallet_watchAsset', params })
          .then(() => console.log('Success, Token added!'))
          .catch((error) => console.log('Error: ' + error.message));
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>


<style scoped>
.footer {
  background-color: #282c34;
  color: white;
  text-align: center;
  padding: 1rem 0;
}

.footer-content {
  display: flex;
  justify-content: center;
  gap: 2rem;
}

.footer-content a {
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-content a:hover {
  color: #61dafb;
}

.footer-content i {
  font-size: 1.5rem;
}

.footer-logo {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.footer-logo img {
  width: 30px;
  height: 30px;
}

.footer-logo span {
  color: white;
  font-size: 1rem;
}
</style>